import { Link } from 'react-router-dom'

import { People } from './styled'
import { PersonType } from 'models'
import { useLocale } from 'locale'

type Props = {
  filteredPeople: PersonType[]
}

export const PeopleList = ({ filteredPeople }: Props) => {
  const locale = useLocale()

  return filteredPeople.length ? (
    <People>
      {filteredPeople.map(p => (
        <li key={p.id}>
          <Link to={`/detail/${p.id}`}>
            <span>{p.Name}</span>
            <span>{p.Surname}</span>
          </Link>
        </li>
      ))}
    </People>
  ) : (
    <p>{locale.home.noResults}</p>
  )
}
